module.exports = __webpack_public_path__ + "img/TinyTrainingPoster.d6646abb.png";